import { VALIDATIONS, buildValidation } from '~utils/inputValidations';

import { FIELDS } from './constants';

export const validationSchema = schema => buildValidation(schema);

export const getCompanyCallCenter = (idCompany, companies) => companies?.find(({ id }) => idCompany === id);

const defaultSchema = {
  [FIELDS.commercialName]: VALIDATIONS.comercialNameCreation,
  [FIELDS.identificationNumber]: VALIDATIONS.identificationNumberRequired,
  [FIELDS.commercialPhone]: VALIDATIONS.phoneCreation,
  [FIELDS.tradeName]: VALIDATIONS.nameCreation,
  [FIELDS.commercialEmail]: VALIDATIONS.emailValidation,
  [FIELDS.identificationType]: VALIDATIONS.identificationNifRequired
};

export const FORM_SCHEMAS = {
  cl: { ...defaultSchema },
  cr: { ...defaultSchema },
  es: {
    ...defaultSchema,
    [FIELDS.faxNumber]: VALIDATIONS.faxCreation,
    [FIELDS.identificationNumber]: VALIDATIONS.identificationNifRequired,
    [FIELDS.commercialTextAddress]: VALIDATIONS.textRequired,
    [FIELDS.commercialCity]: VALIDATIONS.textRequired,
    [FIELDS.commercialPostalCode]: VALIDATIONS.textRequired
  },
  pt: {
    ...defaultSchema,
    [FIELDS.faxNumber]: VALIDATIONS.faxCreation,
    [FIELDS.identificationNumber]: VALIDATIONS.identificationNifRequired,
    [FIELDS.commercialTextAddress]: VALIDATIONS.textRequired,
    [FIELDS.commercialCity]: VALIDATIONS.textRequired,
    [FIELDS.commercialPostalCode]: VALIDATIONS.textRequired
  },
  pa: {
    ...defaultSchema
  },
  gt: {
    ...defaultSchema,
    [FIELDS.commercialTextAddress]: VALIDATIONS.textRequired,
    [FIELDS.commercialPostalCode]: VALIDATIONS.commercialPostalCode,
    [FIELDS.identificationNumber]: VALIDATIONS.identificationNumberRequired
  }
};
